module.exports = __webpack_public_path__ + "img/V34.b33e133d.jpg";